import { SvgIcon, SxProps, Theme } from "@mui/material";

export const CheckedIcon = ({
  sx = { width: "24px", height: "24px" },
}: {
  sx?: SxProps<Theme>;
}) => {
  return (
    <SvgIcon sx={{ ...sx }}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 1.1547C11.2376 0.440169 12.7624 0.440169 14 1.1547L20.3923 4.8453C21.6299 5.55983 22.3923 6.88034 22.3923 8.3094V15.6906C22.3923 17.1197 21.6299 18.4402 20.3923 19.1547L14 22.8453C12.7624 23.5598 11.2376 23.5598 10 22.8453L3.6077 19.1547C2.37009 18.4402 1.6077 17.1197 1.6077 15.6906V8.3094C1.6077 6.88034 2.37009 5.55983 3.6077 4.8453L10 1.1547Z"
          fill="#FFCD4C"
        />
        <path
          d="M9 12.7L10.8462 14.5L15 10"
          stroke="#262423"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default CheckedIcon;
